import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.info-slider');

    carousels.forEach((carouselElement) => {
        if (carouselElement) {
            // Get the unique ID of this slider
            const sliderId = carouselElement.id;

            // Get the navigation buttons specific to this slider
            const nextButton = document.querySelector(`.info-button-next[data-slider="${sliderId}"]`);
            const prevButton = document.querySelector(`.info-button-prev[data-slider="${sliderId}"]`);

            // Get total slides per view from the data-slides attribute or default to 1.3
            const slidesPerView = parseFloat(carouselElement.getAttribute('data-slides')) || 1.3;

            // Initialize Swiper for this carousel
            new Swiper(carouselElement, {
                modules: [Navigation],
                a11y: true,
                loop: false,
                grabCursor: true,
                centeredSlides: false,
                slidesPerView: 1.25,
                spaceBetween: 30,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    992: {
                        slidesPerView: slidesPerView,
                        spaceBetween: 30,
                    },
                },
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                on: {
                    init: function() {
                        // Add initialization class to help with styling if needed
                        carouselElement.classList.add('swiper-initialized');
                    }
                }
            });
        }
    });
});